import React, { useId, PropsWithChildren, ReactNode } from "react";
import cx from "classnames";
import DOMPurify from "dompurify";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { dataTestIds } from "data-testids";
import { useIsMobile } from "../../../generics/dom-extensions";
import "./styles.scss";

export interface TooltipProps {
  title?: string;
  html?: string;
  content?: ReactNode;
  datatestid?: string;
  disabled?: boolean;
  tooltipClassName?: string;
  className?: string;
}

const Tooltip = ({
  title,
  html,
  content,
  children,
  disabled,
  datatestid,
  className,
  tooltipClassName,
}: PropsWithChildren<TooltipProps>) => {
  const id = useId();
  const isMobile = useIsMobile();

  if (disabled) return <>{children}</>;

  return (
    <>
      {children && (
        <span
          data-tooltip-id={id}
          className={className}
          data-testid={dataTestIds.componentLibrary["Molecules.Tooltip.Icon"]}
        >
          {children}
        </span>
      )}
      <ReactTooltip
        id={id}
        clickable
        className={cx("tooltip", tooltipClassName)}
        opacity={0.84}
        openOnClick={isMobile}
        globalCloseEvents={{
          escape: true,
          scroll: true,
          clickOutsideAnchor: true,
        }}
        portalRoot={document.body}
      >
        <div data-testid={datatestid}>
          {title && <p className="font-semibold">{title}</p>}
          {html ? (
            <p
              className="whitespace-pre-line break-words font-normal"
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }}
            />
          ) : (
            <p className="break-words font-normal">{content}</p>
          )}
        </div>
      </ReactTooltip>
    </>
  );
};

export default Tooltip;
